import { useCallback } from 'react';

/**
 * Hook for handling call log row selection
 */
export function useCallLogSelection(onRowClick?: (callLog: any) => void) {
  const handleRowSelected = useCallback(
    (args: any) => {
      if (onRowClick && args.data) {
        onRowClick(args.data);
      }
    },
    [onRowClick]
  );

  return {
    handleRowSelected,
  };
}
